import { render, staticRenderFns } from "./InterviewVideos.vue?vue&type=template&id=0b608465&scoped=true&"
import script from "./InterviewVideos.vue?vue&type=script&lang=js&"
export * from "./InterviewVideos.vue?vue&type=script&lang=js&"
import style0 from "./InterviewVideos.vue?vue&type=style&index=0&id=0b608465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b608465",
  null
  
)

export default component.exports